
const About = () => {
  const achievements = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'Formación Especializada',
      description: 'Graduado en Veterinaria con especialización en cirugía de pequeños animales. GpCert Small Animal Surgery.'
    },
    {
      icon: 'ri-award-line',
      title: 'Experiencia Comprobada',
      description: 'Más de 25 años realizando cirugías especializadas'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Tecnología Avanzada',
      description: 'Sellador vascular Harmonic, motor quirúrgico, motor de neurocirugía, instrumentación específica, lupas quirúrgicas de magnificación, equipo de cirugía mínimamente invasiva (UHD), artroscopía de alta definición'
    },
    {
      icon: 'ri-heart-line',
      title: 'Cuidado Integral',
      description: 'Seguimiento personalizado desde el diagnóstico hasta la recuperación completa'
    }
  ];

  return (
    <section id="sobre-mi" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Imagen */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-full h-[600px]">
              <img 
                src="https://static.readdy.ai/image/33540390f643937a387ee69ee6db3814/5a6f77a5b7da8580d45395946f8fb155.jpeg"
                alt="Pablo Conejero - Veterinario especialista en cirugía - Traumatología y TPLO"
                title="Cirujano veterinario - Pablo Conejero - Especialista en TPLO y traumatología"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent"></div>
            </div>
            
            {/* Elemento decorativo */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-accent-400 to-accent-600 rounded-full opacity-20"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full opacity-20"></div>
          </div>

          {/* Contenido */}
          <div>
            <h2 className="text-4xl md:text-5xl font-display font-bold text-primary-800 mb-6">
              Dr. Pablo Conejero
            </h2>
            
            <h3 className="text-2xl font-semibold text-accent-600 mb-8">
              Cirujano Veterinario Especializado en Pequeños Animales
            </h3>
            
            <div className="space-y-6 text-neutral-700 leading-relaxed">
              <p className="text-lg">
                Con 25 años dedicados en exclusiva a la cirugía veterinaria avanzada, mi objetivo es ofrecer soluciones quirúrgicas seguras, precisas y adaptadas a cada paciente en Almería, Aguadulce, Roquetas de Mar y toda Andalucía Oriental. Mi especialización en traumatología y cirugía TPLO me permite ofrecer los mejores resultados.
              </p>
              
              <p>
                Me especializo en traumatología, cirugía de tejidos blandos avanzada, cirugía torácica con técnicas mínimamente invasivas, cirugía avanzada del ligamento cruzado (TPLO), oncología y neurocirugía veterinaria. Ofrezco servicios de cirugía especializada de máxima calidad.
              </p>
              
              <p>
                Como cirujano veterinario, combino precisión técnica, el equipamiento más avanzado del mercado, la instrumentación de la máxima calidad y una comunicación cercana y empática con cada clínica veterinaria y familia. Mi experiencia en traumatología y TPLO garantiza resultados óptimos.
              </p>
              
              <p>
                Mi servicio móvil de cirugía especializada permite que llegue directamente a tu centro veterinario en Almería capital y toda su provincia además de provincias limítrofes, reduciendo desplazamientos y estrés para el paciente y sus familias. Ofrezco traumatología, TPLO y oncología en tu propia clínica.
              </p>
            </div>

            {/* Logros y características */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">
              {achievements.map((achievement, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${achievement.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-primary-800 mb-2">{achievement.title}</h4>
                    <p className="text-sm text-neutral-600">{achievement.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
